import style from './P2PResultPage.css';
import P2PResultErrorFeedbackScreen from '../../components/PeerToPeer/P2PResultErrorFeedbackScreen/P2PResultErrorFeedbackScreen';
import P2PResultSuccessFeedbackScreen from '../../components/PeerToPeer/P2PResultSuccessFeedbackScreen/P2PResultSuccessFeedbackScreen';

const P2PResultType = {
  ERROR: 'error',
  SUCCESS: 'success',
};

const P2PResultFeedbackScreen = {
  [P2PResultType.ERROR]: P2PResultErrorFeedbackScreen,
  [P2PResultType.SUCCESS]: P2PResultSuccessFeedbackScreen,
};

export default function P2PResultPage({ type, ...props }) {
  const FeedbackScreen = P2PResultFeedbackScreen[type];

  return <FeedbackScreen className={style.container} {...props} />;
}

P2PResultPage.Type = P2PResultType;
